import { render, staticRenderFns } from "./NewPerfilPerm.vue?vue&type=template&id=105ec194&scoped=true&"
import script from "./newPerfilPerm.ts?vue&type=script&lang=ts&"
export * from "./newPerfilPerm.ts?vue&type=script&lang=ts&"
import style0 from "./NewPerfilPerm.vue?vue&type=style&index=0&id=105ec194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105ec194",
  null
  
)

export default component.exports